import { defineInterface } from '@nzyme/ioc/Interface.js';
import { defineService } from '@nzyme/ioc/Service.js';
/**
 * Log a message to the console.
 */
export const consoleLog = (logger, level, message, obj) => {
    if (logger) {
        message = `[${logger}] ${message}`;
    }
    if (obj) {
        console[level](message, obj);
    }
    else {
        console[level](message);
    }
};
/** Injectable interface for the logger transport, defaults to console logging. */
export const LoggerTransport = defineInterface({
    name: 'LoggerTransport',
    default: () => consoleLog,
});
/**
 * A console logger transport.
 */
export const ConsoleLoggerTransport = defineService({
    name: 'ConsoleLoggerTransport',
    implements: LoggerTransport,
    setup: () => consoleLog,
});
//# sourceMappingURL=LoggerTransport.js.map